import { FC, Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/store/store';
import { getRoute } from '@/routes/Routes.helpers';
import ImgTabbarBg from '@/assets/svg/img_tabbar_bg.svg?react';
import { TAB_MENU_LIST } from '@/components/widgets/TabBarWidget/TabBarWidget.config';
import styles from '@/components/widgets/TabBarWidget/TabBarWidget.module.scss';
import TabBarWidgetMenu from '@/components/widgets/TabBarWidget/TabBarWidgetMenu/TabBarWidgetMenu.component';

export const TabBarWidget: FC = () => {
    const { pathname } = useLocation();

    const { isBottomSheetOpen } = useAppSelector((state) => state.siteConfig);

    return (
        <nav
            className={`${styles.tabBarWidgetWrapper} ${isBottomSheetOpen ? styles.hideMenu : ''}`}
        >
            {TAB_MENU_LIST.map((routeKey, index) => {
                const route = getRoute(routeKey);
                const { path, icon, label } = route || {};

                return path ? (
                    <Fragment key={path}>
                        <Link
                            to={path}
                            className={`flcol ${styles.link} ${pathname === path ? styles.active : ''}`}
                        >
                            {icon}
                            <span>{label}</span>
                        </Link>

                        {index === 1 && (
                            <div className={`flc ${styles.centralWrapper}`}>
                                <ImgTabbarBg className={styles.tabbarBg} />
                                <TabBarWidgetMenu isNeedHighlight />
                            </div>
                        )}
                    </Fragment>
                ) : null;
            })}
        </nav>
    );
};
